import React, {
    useContext, useCallback, useEffect, useState
} from 'react';
import _ from 'lodash';
import { ModalNextProvider } from '@jutro/components';
import { TranslatorContext } from '@jutro/locale';
import { BreakpointTrackerContext } from '@jutro/layout';
import { WizardPage, wizardProps } from 'gw-portals-wizard-react';
import { ViewModelServiceContext, ViewModelForm } from 'gw-portals-viewmodel-react';
import { useValidation } from 'gw-portals-validation-react';
import { useDependencies } from 'gw-portals-dependency-react';
import { useAuthentication } from 'gw-digital-auth-react';
import { commonMessages } from 'gw-capability-quoteandbind-common-react';
import metadata from './RiskAnalysisPage.metadata.json5';
import messages from './RiskAnalysisPage.messages';
import styles from './RiskAnalysisPage.module.scss';

function RiskAnalysisPage(props) {
    const translator = useContext(TranslatorContext);
    const breakpoint = useContext(BreakpointTrackerContext);
    const { wizardData: submissionVM, updateWizardData, quoteData, updateQuotedData } = props;
    const viewModelService = useContext(ViewModelServiceContext);
    const { LoadSaveService } = useDependencies('LoadSaveService');
    const { authHeader } = useAuthentication();
    const [isPageInitialized, setPageInitialized] = useState(false);
    const {
        registerInitialComponentValidation,
        isComponentValid,
        disregardFieldValidation,
        initialValidation,
        onValidate
    } = useValidation('baRiskAnalysisPage');


    useEffect(() => {
        // if (_.isEmpty(submissionVM.baseData.priorLossHistoryRecords.value)) {
        //     // eslint-disable-next-line no-param-reassign
        //     submissionVM.baseData.priorLossHistoryRecords.value = [];
        //     updateWizardData(submissionVM);
        // }

        //submissionVM.baseData.priorLossHistoryRecords.forEach((item) => {return item.isAutoValidationRequired.value = true} );        
         submissionVM.baseData.priorLossHistoryRecords.forEach((item) => {
            if(item.isAutoValidationRequired != undefined){
                return item.isAutoValidationRequired.value = true} 
            });
        

        submissionVM.baseData.hasUserVisitedRiskPage_EY.value = true;        
        setPageInitialized(true);        // The above action only need to run once when the page is mounted
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const addAdditionalInterest = useCallback(() => {
        const homeAdditionalInterests = _.get(
            submissionVM,
            'baseData.priorLossHistoryRecords'
        );

        // initialize additional interest VM
        homeAdditionalInterests.value = homeAdditionalInterests.value || [];
        const { _xCenter, _dtoName } = homeAdditionalInterests;
        const additionalVM = viewModelService.create({
            "productLine": submissionVM.baseData.productCode.value,
            "source": "portal_ey"
        }, _xCenter, _dtoName);
        // initialize additional interest VM
        //const addPolicyInterest = additionalVM.policyAdditionalInterest;
        //addPolicyInterest.value = addPolicyInterest.value || {};
       // addPolicyInterest.primaryAddress.value = addPolicyInterest.primaryAddress.value || {};
        //additionalVM.policyAdditionalInterest = addPolicyInterest;
        homeAdditionalInterests.pushElement(additionalVM);
        updateWizardData(submissionVM);
    }, [submissionVM, updateWizardData, viewModelService]);

    const removeAdditionalInterest = useCallback(
        (evt) => {
            const additionInterestPath = evt.path;
            // removes `.children.index` and replace with `.value`
            // so we can get an array of Additional Interests
            const additionalInterestListPath = additionInterestPath.replace(
                /\.children\.\d+$/,
                '.value'
            );
            const additionalInterestToRemove = _.get(submissionVM, additionInterestPath);
            const additionalInterestList = _.get(submissionVM, additionalInterestListPath);

            ModalNextProvider.showConfirm({
                title: messages.removeClaimHeading,
                message: messages.removeClaimBody,
                status: 'warning',
                icon: 'mi-error-outline',
                confirmButtonText: messages.additionalModalYes,
                cancelButtonText: messages.additionalModalNo
            }).then(
                (results) => {
                    if (results === 'cancel') {
                        return _.noop();
                    }
                    const newAdditionalInterestList = additionalInterestList.filter(
                        (additionalInterest, index) => {
                            // eslint-disable-next-line
                            const additionalInterestListPathWithoutValue = additionalInterestListPath.replace(
                                '.value',
                                ''
                            );
                            const currentAdditionalInterestPath = `${additionalInterestListPathWithoutValue}.children.${index}`;
                            // eslint-disable-next-line
                            const isCorrectPath = currentAdditionalInterestPath === additionInterestPath;

                            return !(
                                isCorrectPath
                                && _.isEqual(additionalInterest, additionalInterestToRemove.value)
                            );
                        }
                    );

                    _.set(submissionVM, additionalInterestListPath, newAdditionalInterestList);
                    updateWizardData(submissionVM);
                    return true;
                }, _.noop
            );
        },
        [submissionVM, updateWizardData]
    );

    const additionalInterest = _.get(
        submissionVM,
        'baseData.priorLossHistoryRecords.value'
    );
    const overrideTitleProps = useCallback(() => {
        if (additionalInterest !== undefined) {
            const overrideProps = additionalInterest.map((value, index) => {
                _.set(submissionVM, `baseData.priorLossHistoryRecords.children.${index}.isAutoValidationRequired`, true);
                if (value.atFaultPercent > 25) {
                    _.set(submissionVM, `baseData.priorLossHistoryRecords.children.${index}.chargeable`, value.atFaultPercent > 25);
                }
                return {
                // [`baAdditionalInterest${index}`]: {
                //     visible: index === 0
                // },
                    [`baAdditionalInterestCount${index}`]: {
                    // visible: index > 0,
                        content: translator(messages.claimCount, {
                            count: index + 1
                        })
                    },
                    [`lossDriver${index}`]: {
                        availableValues: submissionVM.lobData.businessAuto.coverables.drivers.value.map((c) => {
                            return {
                                code: c.publicID,
                                name: c.person.displayName
                            };
                        })
                    },
                    [`lossVehicle${index}`]: {
                        availableValues: submissionVM.lobData.businessAuto.coverables.vehicles.value.map((c) => {
                            c['id'] = c.publicID;
                            return c;
                        })
                    },
                    [`chargeableReadOnly${index}`]: {
                        visible: value.atFaultPercent > 25,
                        value: true
                    },
                    [`chargeable${index}`]: {
                        visible: !(value.atFaultPercent > 25)
                    }
                };
            });

            return Object.assign({}, ...overrideProps);
        } else {return null}
    }, [additionalInterest, translator]);

    const validateCoverages = () => {
        var isCoveragesValid = true
        submissionVM.baseData.priorLossHistoryRecords.children.forEach((riskUnit) => {
            if(!( _.get(riskUnit, 'hasLiabilty.value') || _.get(riskUnit, 'hasAb.value') || _.get(riskUnit, 'hasComp.value') || _.get(riskUnit, 'hasApColl.value') || _.get(riskUnit, 'hasDcpd.value') || _.get(riskUnit, 'hasSp.value'))){
                isCoveragesValid = false;
            }            
        })
        return isCoveragesValid;
    }

    const onNext = useCallback(async () => {
        if(submissionVM.baseData.periodStatus.value.code != "Quoted"){
            updateQuotedData(false);
        }        
        if(!validateCoverages()){
            try{
                await ModalNextProvider.showAlert({
                    title: commonMessages.error,
                    message: translator(messages.selectOneCoverage),
                    status: 'error',
                    icon: 'mi-error-outline'
                })
            } catch(err){

            }
            
            return false;
        }
        _.unset(submissionVM.value, 'bindData');
        submissionVM.value = await LoadSaveService.updateDraftSubmission(
            submissionVM.value,
            authHeader
        );
        submissionVM.value = await LoadSaveService.saveAndQuoteSubmission(
            submissionVM.value,
            authHeader
        );
        return submissionVM;
    }, [LoadSaveService, authHeader, submissionVM, translator, messages]);

    const overrideProps = {
        '@field': {
            // apply to all fields
            labelPosition: breakpoint === 'desktop' ? 'left' : 'top',
            showOptional: false,
            showRequired: true
        },
        baAddAnotherAdditionalInterest: {
            visible: additionalInterest !== undefined ? additionalInterest.length > 0 : false
        },
        baAddAdditionalInterest: {
            visible: additionalInterest !== undefined ? additionalInterest.length > 0 : false
        },
        ...overrideTitleProps()
    };

    const resolvers = {
        resolveCallbackMap: {
            onAddAdditionalInterest: addAdditionalInterest,
            onRemoveAdditionalInterest: removeAdditionalInterest
        }
    };

    
    const handlePageValidation = useCallback(() => {
        const ratings = _.get(submissionVM.value, 'lobData.homeowners.coverables.rating');
        const quoteData = _.get(submissionVM.value, 'quoteData.offeredQuotes');
        const periodStatus = _.get(submissionVM.value, 'baseData.periodStatus');
        return (
            _.some(quoteData, (quote) => quote.status === 'Quoted')
            && periodStatus === 'Quoted'
            && ratings
        );
    }, [submissionVM]);

    useEffect(() => {
        registerInitialComponentValidation(handlePageValidation);
    }, [handlePageValidation, registerInitialComponentValidation]);

    if (!isPageInitialized) {
        return null;
    }

    const skipWhenValidation = () => {
        return isComponentValid
    }

    return (
        <WizardPage onNext={onNext} disableNext={!isComponentValid} skipWhen={skipWhenValidation}>
            <ViewModelForm
                uiProps={metadata.pageContent}
                model={submissionVM}
                overrideProps={overrideProps}
                onModelChange={updateWizardData}
                onValidationChange={onValidate}
                callbackMap={resolvers.resolveCallbackMap}
                classNameMap={styles}
            />
        </WizardPage>
    );
}

RiskAnalysisPage.propTypes = wizardProps;
export default RiskAnalysisPage;
